module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAANCAYAAACtpZ5jAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoMESQWCXJYLgAAAJhJREFUOMu1lMEJAzEMBFeHwWW4kv25kpQRyMMEUkYq8U+VqAyDwXkd5MCGS+zTTyBmF6SVWC1YUe/nq6WUYLUIAGyzsOB8C863GCNUFcH5BgDyq+PdGQCoaneG5DnHPWcj6F7bStgQPAs7gFfCDuDb4y5Wi1gtknMGSZCcB383K0WGy5sVOXVu/4jITKR7YSEJq0Xkql/xAYS0h85wEUvUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_l.png
// module id = NyqP
// module chunks = 1